module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-6.d5989bdf.png";